import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppMaterialModule } from 'src/app/app-material.module';
import { NgxMaskModule } from 'ngx-mask';
import { SharedComponentsModule } from 'src/app/shared/components/shared-components.module';

import { OrdersHistoryComponent } from './orders-history.component';
import { OrdersHistoryRoutingModule } from './orders-history-routing.module';
import { TableHistoryComponent } from './table-history/table-history.component';
import { CustomPipeModule } from 'src/app/shared/pipes/custom-pipes.module';
import { ExchangeOrdersComponent } from './modals/exchange-orders/exchange-orders.component';
import { SettlementDocumentsComponent } from './modals/settlement-documents/settlement-documents.component';
import { DirectivesModule } from 'src/app/shared/directives/directives.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ExchangeDetailsComponent } from './modals/exchange-details/exchange-details.component';
import { CurrencyMaskInputMode, NgxCurrencyModule } from 'ngx-currency';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { ExchangeDocumentsCheckComponent } from './modals/exchange-documents-check/exchange-documents-check.component';

export const customCurrencyMaskConfig = {
  align: 'right',
  allowNegative: true,
  allowZero: true,
  decimal: ',',
  precision: 2,
  prefix: 'R$ ',
  suffix: '',
  thousands: '.',
  nullable: true,
  min: null,
  max: null,
  inputMode: CurrencyMaskInputMode.FINANCIAL,
};

@NgModule({
  imports: [
    CommonModule,
    OrdersHistoryRoutingModule,
    AppMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    NgxCurrencyModule.forRoot(customCurrencyMaskConfig),
    NgxMaskModule.forChild(),
    SharedComponentsModule,
    CustomPipeModule,
    DirectivesModule,
    PdfViewerModule,
  ],
  declarations: [
    OrdersHistoryComponent,
    TableHistoryComponent,
    ExchangeDetailsComponent,
    ExchangeOrdersComponent,
    SettlementDocumentsComponent,
    ExchangeDocumentsCheckComponent,
  ],
})
export class OrdersHistoryModule {}
